function getTimeDiffMs(t1, t2) {
    return Date.parse(t2) - Date.parse(t1);
}

export { getTimeDiffMs };
//# sourceMappingURL=getTimeDiffMs.js.map
